module.exports = __webpack_public_path__ + "img/build.f8080a2d.svg";